import {
  ENHANCE_COMMENT,
  ENHANCE_COMMENT_FAILURE,
  ENHANCE_COMMENT_SUCCESS,
  ENHANCE_FEED,
  ENHANCE_FEED_SUCCESS,
  ENHANCE_FEED_FAILURE,
  KUDOS_AI_SUGGEST,
  KUDOS_AI_SUGGEST_SUCCESS,
  KUDOS_AI_SUGGEST_FAILURE,
  FEEDBACK_AI_ENHANCE,
  FEEDBACK_AI_ENHANCE_SUCCESS,
  FEEDBACK_AI_ENHANCE_FAILURE,
} from "./constants";

export const enhanceComment = (comment) => {
  return {
    type: ENHANCE_COMMENT,
    payload: comment,
  };
};

export const enhanceCommentSuccess = (comment) => {
  return {
    type: ENHANCE_COMMENT_SUCCESS,
    payload: comment,
  };
};

export const enhanceCommentFailure = (error) => {
  return {
    type: ENHANCE_COMMENT_FAILURE,
    payload: error,
  };
};

export const enhanceFeed = (payload, onSuccess) => {
  return {
    type: ENHANCE_FEED,
    payload,
    onSuccess,
  };
};

export const enhanceFeedSuccess = (feed) => {
  return {
    type: ENHANCE_FEED_SUCCESS,
    payload: feed,
  };
};

export const enhanceFeedFailure = (error) => {
  return {
    type: ENHANCE_FEED_FAILURE,
    payload: error,
  };
};

export const kudosAiSuggest = (payload, onSuccess) => ({
  type: KUDOS_AI_SUGGEST,
  payload,
  onSuccess,
});

export const kudosAiSuggestSuccess = () => ({
  type: KUDOS_AI_SUGGEST_SUCCESS,
});

export const kudosAiSuggestFailure = (error) => ({
  type: KUDOS_AI_SUGGEST_FAILURE,
  payload: error,
});

export const feedbackAiEnhance = (payload, onSuccess) => ({
  type: FEEDBACK_AI_ENHANCE,
  payload,
  onSuccess,
});

export const feedbackAiEnhanceSuccess = () => ({
  type: FEEDBACK_AI_ENHANCE_SUCCESS,
});

export const feedbackAiEnhanceFailure = (error) => ({
  type: FEEDBACK_AI_ENHANCE_FAILURE,
  payload: error,
});
